import Vue from 'vue';
import VueRouter from 'vue-router';
import GetUpdates from '@/views/GetUpdates.vue';
import ConfirmView from '@/views/ConfirmView.vue';
import { Routes } from '@/types/router';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    base: '/'
});

export function addRoutes (getUpdatesUrl: string, confirmUrl: string) {
    router.addRoute({
        path: getUpdatesUrl,
        name: Routes.GetUpdates,
        component: GetUpdates
    });
    router.addRoute({
        path: confirmUrl,
        name: Routes.ConfirmView,
        component: ConfirmView
    });
}

export default router as VueRouter;
